import React from "react";
import { LayoutRoute } from "components/LayoutRoute";
import { Redirect, Switch } from "react-router-dom";
import PageSend from "./PageSend";
import PageReceive from "./PageReceive";
import NoticeLayout from "./NoticeLayout";

export default function Notice() {
    return (
        <Switch>
            <LayoutRoute
                path={`/notice/send`}
                exact
                component={PageSend}
                layout={NoticeLayout}
            />
            <LayoutRoute
                path={`/notice/receive`}
                exact
                component={PageReceive}
                layout={NoticeLayout}
            />
            <Redirect to={`/notice/send`} />
        </Switch>
    );
}
